/**
* Image Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'image-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-banner', COMPONENT );
} )( app );
